import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserService } from '@core/auth/user/user.service';
import { jwtDecode } from 'jwt-decode';
import { BUZZ_RNFI } from 'src/environments/init-config';

export const buzzRnfiInterceptor: HttpInterceptorFn = (req, next) => {

  if (!req.url.includes('https://buzz.rnfi.in/api/')) {
    return next(req);
  }

  let loginsession = inject(UserService).getPartialData('loginsession') as string;


  const headers: Record<string, string> = {
    'Authorization': String(loginsession),
  };

  const decodedToken: any = jwtDecode(loginsession);


  const additionalBody = {
    'token': BUZZ_RNFI.token,
    'loginsession': atob(atob(decodedToken.session))
  };

  // Extract the existing body from the request
  const existingBody = req.body as object;

  // Merge existing body with additionalBody
  const mergedBody = { ...existingBody, ...additionalBody };

  // Clone the request with updated headers and body
  const cloneReq = req.clone({ setHeaders: headers, body: mergedBody });
  return next(cloneReq);
};
